import { z } from "zod";

export const FluxoCaixaSchema = z.object({
    idsBancoPagamento: z.array(z.number()).nullable().optional(),
    idsCentroCusto: z.array(z.number()).nonempty({ message: "Selecione pelo menos um centro de custo." }),
    statusPagamento: z.number().nullable().optional(),
    statusRecebimento: z.number().nullable().optional(),
    dataDe: z.coerce.date({ invalid_type_error: "Data inválida." }).nullable().default(null),
    dataAte: z.coerce.date({ invalid_type_error: "Data inválida." }).nullable().default(null),
    idFornecedor: z.number().nullable().optional(),
    idCliente: z.number().nullable().optional(),
    isEstoque: z.boolean().optional().default(false),

});

export type FluxoCaixaForm = z.infer<typeof FluxoCaixaSchema>;

export const defaultFluxoCaixaForm: Partial<FluxoCaixaForm> = {
    statusPagamento: 3,
    statusRecebimento: 3,
    isEstoque: false,

};

